/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState, useRef } from "react";
import { Editable } from "./MFRData";

const checkIco = require("../assets/esign-ui-icons/ico-check.svg");
const closeIco = require("../assets/esign-ui-icons/ico-close.svg");

function compare(a, b) {
  if (a.id < b.id) {
    return -1;
  }
  if (a.id > b.id) {
    return 1;
  }
  return 0;
}

const LeadDetailsGraph = ({ data = [], dataKey, userInfo, trendKey, onChange = () => null }) => {
  let leftText = { rvImpedance: "RV Lead", raImpedance: "RA Lead", lvImpedance: "LV Lead" };
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [status, setStatus] = useState(null);
  const [value, setValue] = useState(userInfo[dataKey]);
  const [oldValue, setOldValue] = useState(userInfo[dataKey]);
  const [display, setDisplay] = useState(false);
  const to = useRef(null);
  useEffect(() => {
    data.sort(compare);
    setDisplay(true);
  }, []);

  useEffect(() => {
    if (isSuccess != null) {
      setTimeout(() => {
        setIsSuccess(null);
      }, 3000);
    }
  }, [isSuccess]);

  const updateStatus = (value) => {
    if (to.current) clearTimeout(to.current);

    setStatus(value);
    to.current = setTimeout(() => {
      setStatus(null);
    }, 3000);
  };

  const onChangeValue = async (message) => {
    try {
      setIsLoading(true);
      const lS = window.localStorage.getItem("genToken");
      setValue(message);
      let url = "/patientmanagement/rest/interrogations/" + userInfo.id;
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          token: JSON.parse(lS)["token"],
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: userInfo.id + "",
          [dataKey]: message,
        }),
      });
      if (response.ok) {
        setIsLoading(false);
        onChange({ key: trendKey, value: message, dataKey });
        setIsSuccess(true);
        setOldValue(message);
      } else {
        updateStatus(false);
        setIsLoading(false);
        setIsSuccess(false);
        setValue(oldValue);
      }
      return response;
    } catch (err) {
      updateStatus(false);
      setIsLoading(false);
      setValue(oldValue);
    }
  };

  return (
    <div style={{ padding: "0 5px", flex: 1, display: "flex", height: 150, flexDirection: "column" }}>
      <img style={{ position: "absolute", top: -1000, left: -1000 }} src={checkIco} />
      <img style={{ position: "absolute", top: -1000, left: -1000 }} src={closeIco} />
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 5 }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          {leftText[dataKey]}:
          <div className="col-edit" style={{ marginLeft: 3 }}>
            {display ? (
              <Editable
                onSubmit={onChangeValue}
                initialValue={value}
                isVisibleInput={true}
                isLoading={isLoading}
                isError={typeof status === "boolean" ? !status : undefined}
              />
            ) : null}
            {!isLoading && isSuccess !== null ? (
              <div
                className={`${isSuccess ? "check-ico" : "close-ico"} icon-64`}
                style={{ height: 15, width: 15, marginLeft: 5 }}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadDetailsGraph;
